__turbopack_context__.v({
  "grid": "MediaGallery-module-scss-module__faLz9G__grid",
  "showMore": "MediaGallery-module-scss-module__faLz9G__showMore",
  "tile": "MediaGallery-module-scss-module__faLz9G__tile",
  "tileIcon": "MediaGallery-module-scss-module__faLz9G__tileIcon",
  "tileImage": "MediaGallery-module-scss-module__faLz9G__tileImage",
  "tileOverlay": "MediaGallery-module-scss-module__faLz9G__tileOverlay",
});
